import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=84f58794&scoped=true"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"
import style0 from "./page-header.vue?vue&type=style&index=0&id=84f58794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f58794",
  null
  
)

export default component.exports